import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
        <Leaf className="h-10 w-10 text-green-700 animate-pulse" />
        <p className="mt-3 text-slate-500 text-sm">Memuat sistem...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
